$(document).ready(function() {
  $(".list-group").each(function() {
    if ($(this).find(".active").length > 0) {
      $(this)
        .find(".fa-plus")
        .addClass("fa-minus")
        .removeClass("fa-plus");
      $(this)
        .find(".collapse")
        .addClass("show");
    }
  });
  $("[data-toggle='collapse']").on("click", function() {
    if ($(this).find(".fa-plus").length > 0) {
      $(this)
        .find(".fa-plus")
        .addClass("fa-minus")
        .removeClass("fa-plus");
    } else {
      $(this)
        .find(".fa-minus")
        .addClass("fa-plus")
        .removeClass("fa-minus");
    }
  });
  $("#watershedNavBtn").on("click", function() {
    $("#watershedNav").slideToggle();
    $("#watershedNavOpen, #watershedNavClose").toggle();
  });
});
